import { desktopFirstMediaQuery, Stack, Title } from '@inflearn/ds-react';
import type { MantineColor } from '@mantine/core';

type Props = {
  title: string;
  subTitle: string;
  color?: MantineColor;
};

export default function PageTitle({ title, subTitle, color = 'gray.9' }: Props) {
  return (
    <Stack
      mx={'auto'}
      maw={1200}
      css={{
        padding: '60px 32px',
        [desktopFirstMediaQuery.mobile]: {
          padding: '40px 16px'
        }
      }}>
      <Title
        size={60}
        weight={700}
        color={color}
        css={{
          [desktopFirstMediaQuery.mobile]: {
            fontSize: '30px'
          }
        }}>
        {title}
      </Title>
      <Title
        size={30}
        weight={600}
        color={color}
        css={{
          [desktopFirstMediaQuery.mobile]: {
            fontSize: '15px'
          }
        }}>
        {subTitle}
      </Title>
    </Stack>
  );
}
